import React from 'react';
import ParallaxImage from './ParallaxImage';

const VanBand: React.FC = () => (
  <ParallaxImage
    src="/home/van.jpg"
    className="min-h-[440px] md:min-h-[680px]"
    ariaLabel="Outpost Custom signwritten van"
  />
);

export default VanBand;
